import React from 'react';
import { CommonIconProps } from './Icon';

const FlashIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      d="M10.5833 0.580569C9.36268 0.510569 7.28001 0.437903 5.22668 0.587903C4.89275 0.612384 4.57276 0.731699 4.30432 0.931817C4.03588 1.13194 3.83016 1.40454 3.71134 1.71757C2.67601 4.4389 2.18268 6.9489 1.97234 8.2789C1.84068 9.11324 2.44701 9.85724 3.28101 9.91424C3.99368 9.96324 5.04068 10.0142 6.26268 10.0076C6.13268 11.0652 5.99701 12.4766 5.86201 13.9946C5.74168 15.3546 7.37701 16.1722 8.35034 15.1292C10.8493 12.4516 13.1403 9.4739 14.3963 7.7769C15.0877 6.84357 14.479 5.53757 13.2987 5.5069C12.6333 5.49017 11.9676 5.48494 11.302 5.49124C11.5343 4.47857 11.7443 3.37824 11.9373 2.31624C12.094 1.4539 11.4763 0.631903 10.5833 0.580569Z"
      fill={color}
    />
  </>
);

export default FlashIcon;

FlashIcon.prototype.svgPropOverrides = { viewBox: '0 0 16 16' };
